import React from 'react';

import { observer } from 'mobx-react';

import { EntityModules } from 'core/constants';

import EntitySection from 'components/Entities/EntityDetailsTab/EntitySection';
import { BackgroundInformationSections } from 'components/Entities/EntityDetailsTab/styles';
import type { TabComponentProps } from 'components/Entities/EntityDetailsContent/types';

import { getFixedSection } from 'stores/EntityLayout/fixedSections';

const RiskScoringTab: React.FunctionComponent<TabComponentProps> = ({ store }) => {
  const scoring = getFixedSection(EntityModules.Risks);
  const section = scoring && store.details?.layout.properties[scoring.key];

  if (!scoring || !section) {
    return <></>;
  }

  return (
    <BackgroundInformationSections data-testid="risk-scoring-tab">
      <EntitySection sectionKey={scoring.key} title={section.title} fieldOrder={section.order} store={store} />
    </BackgroundInformationSections>
  );
};

export default observer(RiskScoringTab);
